// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d8fb9807","389":"7050cef2","453":"0ec2cc0b","732":"7f5ae93f","857":"e73e9eed","977":"630c0ded"}[chunkId] + ".chunk.js";
};